<template>
  <Dialog
      v-model="dialogVisibleTips"
      :title="$t('sys.team.info')"
      :width="'420'"
      :dialogVisible="dialogVisibleTips"
      @update:dialogVisible="close"
      align-center
  >
    <template #content>
      <div class="inners_warning">
        <span style="font-size: 14px;">{{
            isSelectAll ? $t('common.setting.move.all.sea') : $t('common.setting.move.target.sea')
          }}
        </span>
      </div>
    </template>
    <template #footer>
      <div class="setting_center">
        <el-button size="small" @click="close">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleDelete" :loading="isLoadingMove">{{ $t('common.confirm') }}</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Dialog.vue";
import {defineProps, ref, watch, defineEmits, computed} from "vue";
import {useRouter} from "vue-router";
import {batchDeleteCustomerById} from "@/api/customer";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {throttle} from "@/utils/mylodash"
import {TIME_OUT} from "@/utils/statusParams";
import {i18n} from "@/lang";

const router = useRouter()
const emit = defineEmits()
const dialogVisibleTips = ref(false)
const store = useStore()

const {
  isLoadingMove,
  value,
  multipleSelection,
  getCustomerList,
  isSelectAll,
  searchValue,
  isDetail,
  type
} = defineProps({
  value: {type: Boolean, default: false},
  multipleSelection: {type: Array, default: () => []},
  getCustomerList: {type: Function},
  isSelectAll: {type: Boolean, default: false},
  searchValue: {type: Object, default: {}},
  isDetail: {type: Boolean, default: false},
  type: {type: Number, default: 1},
  isLoadingMove: {type: Boolean, default: false}
})

watch(() => value, (val) => {
  dialogVisibleTips.value = val;
}, {immediate: true})


const close = () => {
  emit("close")
}
const isloading = ref(false)
const teamId = computed(() => store.state.email.teamID)
const handleDelete = throttle(async () => {
  emit('public')
}, TIME_OUT)


</script>

<style lang="less" scoped>
.inners_warning {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
}

.setting_center {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
